import React from 'react';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
export function EditCreditType() {
  return <div className="space-y-6 max-w-xl mx-auto" data-id="element-202">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-203">Edit Credit Type</h1>

      <Card data-id="element-204">
        <CardContent className="space-y-6 pt-6" data-id="element-205">
          <Input label="Name" placeholder="Enter credit type name..." data-id="element-206" />

          <div className="pt-4" data-id="element-207">
            <Button data-id="element-208">Submit</Button>
          </div>
        </CardContent>
      </Card>
    </div>;
}